import { DateTime } from 'luxon'
import { useSelector } from 'react-redux'

import { type TimezonesEnum } from '@webapp/core/entities/external/enums/TimezonesEnum'
import { makeSelectHeadquartersTimezone } from '@webapp/core/stores/global'

export const useFormatISOStringToDate = () => {
  const headquartersTimezone = useSelector(makeSelectHeadquartersTimezone())

  return (
    isoDateTimeString: string,
    timezone: TimezonesEnum,
    useHeadQuarterTimezone: boolean = false
  ) => {
    if (!isoDateTimeString || (!useHeadQuarterTimezone && !timezone)) {
      console.error(
        'isoDateTimeString and timezone values are required arguments'
      )
    }

    const { day, month, year, hour, minute, second } = DateTime.fromISO(
      isoDateTimeString,
      { zone: useHeadQuarterTimezone ? headquartersTimezone : timezone }
    ).toObject()

    return new Date(year, month - 1, day, hour, minute, second)
  }
}
